<div>
  <button mat-button mat-dialog-close style="float: right">
    <mat-icon>close</mat-icon>
  </button>
</div>
  <ejs-grid
    mat-dialog-content
    #ChangeHistoryGrid
    style="margin-top: 10px;height: 100%;clear: both;"
    [dataSource]='ChangeHistoryList'
    [allowPaging]="true"
    [allowSorting]="true"
    [allowFiltering]="true"
    [filterSettings]="{type: 'Excel'}"
    [allowTextWrap]="true"
    [textWrapSettings]="{ wrapMode: 'Both' }"
    [pageSettings]="{pageSize:25}"
    [allowGrouping]="true"
    [groupSettings]="{showDropArea: true, disablePageWiseAggregates: true, columns:['ChangeTimestamp','ChangeItemType','ChangeType','ChangeItemID']}"
    [allowMultiSorting]="true"
  >
    <e-columns>
      <e-column field='ChangeTimestamp' headerText='Timestamp'></e-column>
      <e-column field='ChangeUser' headerText='EmpID'></e-column>
      <e-column field='ChangeDept' headerText='Lab'></e-column>
      <e-column field='ChangeType' headerText='Change Type'></e-column>
      <e-column field='ChangeItemID' headerText='Record ID'></e-column>
      <e-column field='ChangeItemType' headerText='Record Type'></e-column>
      <e-column field='ChangeItemField' headerText='Field'></e-column>
      <e-column field='OldValue' headerText='Old Value'></e-column>
      <e-column field='NewValue' headerText='New Value'></e-column>

    </e-columns>
  </ejs-grid>
